export const UPDATE_DATA = "UPDATE_DATA";
export const LOGOUT = "LOGOUT";
export const LOGIN = "LOGIN";
export const PLAY_GAME = "PLAY_GAME";
export const INVITED = "INVITED";
export const INVITE_PLAYER = "INVITE_PLAYER";
export const SET_COLOR = "SET_COLOR";
export const SET_DID_REDIRECT = "SET_DID_REDIRECT";
